import React, { useState, useEffect } from 'react';
import { getMessageCount } from 'services/freeMessageLimit';
import {
    CounterContainer,
    CounterBadge,
    CounterText,
    CounterNumber,
    UpgradeLink
} from './styled';

const MessageCounter = ({ characterId, isPremium, onUpgradeClick }) => {
    const [messageData, setMessageData] = useState({ count: 0, remaining: 20 });

    useEffect(() => {
        const loadMessageCount = async () => {
            const data = await getMessageCount(characterId);
            setMessageData(data);
        };
        if (!isPremium && characterId) {
            loadMessageCount();
            // Recarrega quando volta para a tela (ou a cada 5s para refletir incrementos)
            const interval = setInterval(loadMessageCount, 5000);
            return () => clearInterval(interval);
        }
    }, [characterId, isPremium]);

    // Não mostra para usuários premium
    if (isPremium) return null;

    const { remaining = 20, limit = 20 } = messageData;
    const isLow = remaining <= 5;
    const isVeryLow = remaining === 0;

    return (
        <CounterContainer>
            <CounterBadge low={isLow} veryLow={isVeryLow}>
                <CounterText>Mensagens gratuitas hoje:</CounterText>
                <CounterNumber low={isLow} veryLow={isVeryLow}>
                    {remaining} / {limit}
                </CounterNumber>
            </CounterBadge>
            {isLow && !isVeryLow && (
                <UpgradeLink onClick={onUpgradeClick}>
                    💎 Tenha mensagens ilimitadas
                </UpgradeLink>
            )}
        </CounterContainer>
    );
};

export default MessageCounter;
